import React from 'react';
import PropTypes from 'prop-types';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Relationship from 'facet-rest/src/domain/Relationship';
import ChiliPiperRescheduleMeeting from 'Components/UI/MeetingCard/Combined/ChiliPiperRescheduleMeeting';

const useStyles = buildUseStyles('MeetingTimeDetail', (theme) => ({
  link: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
  },
}));

const RescheduleMeeting = ({
  relationship,
  meetingResource,
  refreshMeetings,
  autoOpen,
}) => {
  const classes = useStyles();
  const openRescheduleModal = (e) => {
    openModal(modalConsts.clientSchedulerModal, [{
      link: relationship.link('related').url(),
    }]);
    e.preventDefault();
  };

  if (relationship.meta('isChiliPiperLink')) {
    return (
      <ChiliPiperRescheduleMeeting
        relationship={relationship}
        meetingResource={meetingResource}
        refreshMeetings={refreshMeetings}
        autoOpen={autoOpen}
      />
    );
  }

  return (
    <a
      onClick={openRescheduleModal}
      href="#"
      test={'my-meetings-meeting-card-reschedule-button'}
      className={classes.link}
    >
      Reschedule Meeting
    </a>);
};

RescheduleMeeting.defaultProps = {
  autoOpen: false,
};

RescheduleMeeting.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  meetingResource: PropTypes.object.isRequired,
  refreshMeetings: PropTypes.func.isRequired,
  autoOpen: PropTypes.bool,
};

export default RescheduleMeeting;
